<template>
  <div>
    <Head title="Work Orders/Issuances" />
    <h1 class="mb-8 text-3xl font-bold">
      Work Orders/Issuance
    </h1>
    <div class="flex items-center justify-between mb-6 mt-6">
      <search-team-dropdown v-model="form.search" :teams="productionLines" class="mr-0 w-full max-w-md"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date Created</th>
          <th class="pb-3 pt-3 px-3">WO Number</th>          
          <th class="pb-3 pt-3 px-3">Production Line</th>
          <th class="pb-3 pt-3 px-3">Bom</th>
          <th class="pb-3 pt-3 px-3">Created By</th>
          <th class="pb-3 pt-3 px-3" colspan="4"></th>
        </tr>
        <tr v-for="work_order in work_orders.data" :key="work_order.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/issuances/create`" tabindex="-1">
              {{ work_order.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/issuances/create`" tabindex="-1">
              {{ work_order.wo_number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/issuances/create`" tabindex="-1">
              {{ work_order.production_line }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/issuances/create`" tabindex="-1">
              {{ work_order.bom }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/issuances/create`" tabindex="-1">
              {{ work_order.user }}
            </Link>
          </td>
        </tr>
        <tr v-if="work_orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="5">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="work_orders.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchTeamDropdown from '@/Shared/SearchTeamDropdown'
import DateRange from '@/Shared/DateRange'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Icon,
    SearchTeamDropdown,
    DateRange,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    work_orders: Object,
    productionLines: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search ? this.filters.search : 'Select Production Line',
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/work-orders/issuances', pickBy(this.form), {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
